// extracted by mini-css-extract-plugin
export default {"title":"select-event_title__lQbD4"};